import { Directive, Input, ElementRef, AfterViewInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { isPresent } from 'app/pages/A2-utils/custom-validators/utils/helpers';

@Directive({
  selector: '[appValidatorsViewErrors]'
})
export class ValidatorsViewErrorsDirective implements AfterViewInit {

  @Input('control') control: AbstractControl;
  private subscribe = false;

  constructor(private element: ElementRef) { }

  buildTextErrors(errors) {
    let msg = '';
    if (isPresent(errors)) {
      if (errors.message) {
        msg = `<p class="color-danger em-0-8 padding-lr-5 ">${errors.message}<p>`;
      }
    }

    this.element.nativeElement.innerHTML = msg;
  }


  _each() {
    if (!this.subscribe && isPresent(this.control)) {
        this.subscribe = true;
        this.control.valueChanges
        .subscribe(() => {
          this.buildTextErrors(this.control.errors);
      });
    }
  }

  ngAfterViewInit(): void {
    this._each();
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/validators-view-errors/validators-view-errors.directive.ts